import { isApiTestActive } from './apiTest';

// Whether a real OIDC login (Entra ID) is attempted at all - independent of which catalog data
// source is used (VITE_CATALOG_SOURCE). By default, the static catalog export also skips login
// entirely (it's meant to run fully offline - see the reasoning this used to carry inline in
// App.tsx/AppRoutes.tsx), but VITE_ENABLE_LOGIN can override that default explicitly either way:
// "true" forces a real login even alongside the static export (e.g. to test something that needs
// a logged-in user, like LandingPage's UserGreeting, without the full REST backend running),
// "false" forces login off even in REST mode. Leave it unset for the previous default behaviour.
export const isStaticCatalog = import.meta.env.VITE_CATALOG_SOURCE === 'static';

// ?apitest=... turns individual routes back on against the live API (see apiTest.ts). Those routes
// are scope-protected, so they need a token - without a login the request would just come back 401.
// An explicit VITE_ENABLE_LOGIN still wins either way: setting it to "false" alongside ?apitest is
// a deliberate choice to watch the API reject an anonymous call.
const explicitLoginFlag = import.meta.env.VITE_ENABLE_LOGIN;
export const isLoginEnabled = explicitLoginFlag ? explicitLoginFlag === 'true' : !isStaticCatalog || isApiTestActive;

// Diagnostic for exactly the question "is login on, and does the app actually have OIDC config to
// act on it": every one of these variables comes from .env and DevTools' generic ways of reading
// import.meta.env from outside a module context don't work reliably (raw console statements aren't
// ES modules; Vite's dev env virtual module only carries the vite.config.ts `define` block, not
// the .env-sourced VITE_ vars for this project's Vite version). Logging it from here - genuine
// module scope - sidesteps all of that. import.meta.env.DEV is Vite's own always-available flag,
// so this never reaches a production build.
if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info('auth config:', {
        isLoginEnabled,
        isStaticCatalog,
        isApiTestActive,
        VITE_ENABLE_LOGIN: explicitLoginFlag,
        VITE_APP_OIDC_AUTHORITY: import.meta.env.VITE_APP_OIDC_AUTHORITY,
        VITE_APP_OIDC_CLIENT_ID: import.meta.env.VITE_APP_OIDC_CLIENT_ID
    });
}
